import { FoundationsButton } from '../../GenericComponents/button'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsConstants } from '../../FoundationsConstants'
import { getBaseUrl, FoundationsRequest, handleHardReload } from '../../Utils'
import { FormValidation } from '../../FormValidationsRules'
import { FoundationsAlert } from '../../GenericComponents/alert'
import { useForm } from 'react-hook-form'
import { useEffect,useState } from 'react'
import Swal from 'sweetalert2';
import { FoundationsForm } from '../../GenericComponents/form'
import { ForgotPasswordFormData,useSubmitFormMutation } from '../../Redux/forgotPassword/forgotPasswordSlice'



declare let window: any
const UnicornApp = window.unicornInstance;

export function ForgotPasswordPage() {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [email, setEmail] = useState('') // TODO => SSO password handling here
    const [sendEmail] = useSubmitFormMutation()

    const onSubmit = async () => {;

        const requestInfo = {EmailAddress: email}
        setIsSubmitting(true);
        setStatusMessage('');

        sendEmail(requestInfo)
            .unwrap()
            .then((response) => {
                if (response && response.data) {
                    Swal.fire({
                        title: 'Reset Password',
                        html: `<p>If the email address you entered was correct, we have sent you an email with instructions on how to reset your password. If you don't receive it, please check your spam folder or ensure the email is correct.</p>`,
                        icon: 'success',
                        confirmButtonText: 'Ok',
                        allowOutsideClick: false,
                    }).then(() => {
                        window.location.href = window.baseURL +"/ux/index.html#signin"; // Redirect to sign-in after success
                    });
                } else {
                    setStatusMessage('Something went wrong. Please try again.');
                }
            })
            .catch(() => {
                setStatusMessage('An error occurred. Please check your email and try again.');
                setIsSubmitting(false);
            })
     
    };

    return (
        <div className="row">
            <div className="col-12 offset-sm-2 col-sm-6" id="forgot_password_form_el">
                <div className="row">
                    <div className="col-12 mb-2 text-left">
                        <div className="header">Forgot your Password</div>
                        <div className="sub-header padding-top-small">
                            Supply your email to begin with.
                        </div>
                    </div>
                    <div className="col-12 mb-2 text-left">
                        We will send you an email with instructions to reset your account password.
                    </div>
                    <div className="col-12">
                        {statusMessage && <div id="status_message">{statusMessage}</div>}
                        <FoundationsForm id="send_form" 
                        handleSubmit={handleSubmit}
                        submitFunction={onSubmit}>
                            <div className="col-12">
                                <FoundationsInput
                                    classes="form-group mb-3 row"
                                    value = {email}
                                    onInput={(e: { target: { value: string } }) => {
                                        setEmail(e.target?.value)
                                    }}
                                    id="user_email"
                                    name="user_email"
                                    type="text"
                                    containerClasses="col-11 col-sm-10 col-md-11 col-lg-9 col-xl-8"
                                    maxLength={50}
                                    labelText="Email:"
                                    labelClasses="col-lg-2 col-xl-3 text-left"
                                    errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                    ariaAutocomplete="none"
                                    autocomplete="off"
                                    registerFunction={register}
                                    registerName="Email"
                                    registerRules={FormValidation.email}
                                    error={errors.Email?.message}
                                >
                                </FoundationsInput>
                            </div>
                            <div className="col-12 text-left mb-2 ml-2">
                                <FoundationsButton
                                    classes="offset-md-3 col-4 pl-0 forgotpassword_button"
                                    id="button_send"
                                    type="submit"
                                    buttonClasses="app-button"
                                    data-is_disabled={isSubmitting}
                                    data-has_loader="true"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Sending...' : 'Send Email'}
                                </FoundationsButton>
                            </div>
                        </FoundationsForm>
                    </div>
                </div>
            </div>
        </div>
    );
}
